import React from 'react';

// Adjusted for Responsive
const Contact = () => {
    return (
        <div className="bg-black contact_info" style={{ height: 20 }}>
            <div className="w3-content d-flex flex-row-reverse white font-10 hind justify-center-768">
                <span className="align-self-center margin-right-half">info@challengesports.com</span>
                <i className="far fa-envelope align-self-center margin-right-half" />
                {/*<span className="align-self-center margin-right-half">|</span>
                <span className="align-self-center margin-right-half">(321) 676-1373</span>
    <i className="fas fa-phone-alt align-self-center margin-right-half" />*/}
            </div>
        </div>
    );
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/layouts/contact.js